let href = window.location.href,
    urlParamsStr = href.split('#')[1],
    urlParams = {}
if(urlParamsStr && urlParamsStr.split('?') && urlParamsStr.split('?').length > 1) {
    urlParamsStr.split('?')[1].split('&').forEach(e=>{
        let split = e.split('=')        
        urlParams[split[0]] = split[1]
    })
};
import urlParse from "@/utils/urlParse";
const urlDataNew = urlParse();
const CLIENTNEW = {
	//本地开发数据，項目中 可以通过  this.$client.userid 的格式来获取
	userid: "", //用户id
	orgid: "", // 机构编號
	shopid: "", // 店铺id
};
console.log(process.env.NODE_ENV, '18')
const clientDataNew =
	process.env.NODE_ENV === "production" ?
	urlDataNew :
	Object.assign({}, CLIENTNEW, urlDataNew);
for(const key in clientDataNew) {
	//这里做一个统一转小写的處理，防止客户端大小写没有传对。
	const val = clientDataNew[key];
	clientDataNew[key] = typeof val === "string" ? val.toLowerCase() : val;
}
//let parmsData=JSON.stringify(clientDataNew);
//console.log(parmsData,'29')
console.log(clientDataNew,'29')
export default {
    timeout: 300000,
    // baseUrl: process.env.VUE_APP_BASEURL,
    // baseUrl: 'http://devcloud.vpclub.cn/',
    // baseUrl: 'https://umall.hk.chinamobile.com/',    
    baseUrl: location.origin.indexOf('umall') != -1 ?  (location.origin +'/'): 'https://devcloud.vpclub.cn/',
    errorMsg: {
        repeat: '操作過於頻繁，請稍後',
        link_failure: '連接服務器失敗，請檢查您的網絡狀態'
    },
    // 请求默认参数
    default: {
        orgId:clientDataNew.orgid || urlParams.orgId || '1003552186595246081',
        shopId:clientDataNew.shopid || urlParams.shopId || '1150939934484463617',
        userId:clientDataNew.userid || urlParams.userId || '1150939934002118656',
        appId: urlParams.appId || '10000188'
    }
}   